/** @jsxImportSource @emotion/react */

import { ReactComponent as AppMobileIcon } from "assets/mobile/icons/app-mobile.svg";
import { ReactComponent as BarsIcon } from "assets/mobile/icons/bars.svg";
import acv88Logo from "assets/mobile/logo-mobile.png";
import { PATH } from "constants/path";
import { useAppDispatch } from "hooks/app-hook";
import { Link } from "react-router-dom";
import { setOpenSidebar } from "store/master";

import { MHeaderStyle } from "./index.style";

const MHeader = () => {
  const dispatch = useAppDispatch();
  return (
    <header css={MHeaderStyle.self}>
      <BarsIcon
        onClick={() => dispatch(setOpenSidebar(true))}
        css={MHeaderStyle.barIcon}
      />
      <div css={MHeaderStyle.logo}>
        <Link to={PATH.Home}>
          <img src={acv88Logo} alt="acv88-logo" />
        </Link>
      </div>
      <div onClick={() => window.open("https://acv188.app/")}>
        <AppMobileIcon css={MHeaderStyle.appMobileIcon} />
      </div>
    </header>
  );
};

export default MHeader;
